export const GATSBY_APP_ENV: 'prod' | 'stg' | 'dev' | 'mockup' | undefined = process.env.GATSBY_APP_ENV as 'prod' | 'stg' | 'dev' | 'mockup' | undefined;
export const IS_PROD: boolean = GATSBY_APP_ENV === 'prod';
export const IS_STG: boolean = GATSBY_APP_ENV === 'stg';
export const IS_DEV: boolean = GATSBY_APP_ENV === 'dev';
export const IS_MOCKUP: boolean = GATSBY_APP_ENV === 'mockup';
